import { Form, Dialog, Image } from 'antd-mobile'
import dayjs from 'dayjs'

import dictStore from '@/store/global/dictStore'

import ListSelect from '../ListSelect'
import TimePicker from '../TimePicker'

import { TimeIntervalArrayProps } from './interface'
import { generateChineseArray } from './utils'

import './index.less'

const INDEX_MAP = generateChineseArray(50)

function TimeIntervalArray({
  form,
  disabled,
  fieldsName = { name: 'shift' },
  showType
}: TimeIntervalArrayProps) {
  const currentDay = Form.useWatch(fieldsName?.currentDay, form)
  const shiftType = Form.useWatch(fieldsName?.shiftType, form)
  const timeIntervalList = Form.useWatch(
    fieldsName?.name ? [fieldsName?.name, 'time_interval_list'] : 'time_interval_list',
    form
  )
  const TodayStr = dayjs().format('YYYY-MM-DD')
  const handleAdd = (operation: any) => {
    const day = currentDay || TodayStr
    const addItem = TimePicker.convertValue(
      undefined,
      {
        name: 'start_end_time',
        names: ['start_date_type', 'start_datetime', 'end_date_type', 'end_datetime'],
        currentDay: day
      },
      {
        start_date_type: 'CURRENT_DAY',
        start_datetime: '09:00',
        end_date_type: 'CURRENT_DAY',
        end_datetime: '18:00'
      }
    )
    if (!currentDay) {
      form.setFieldValue(fieldsName?.currentDay, TodayStr)
    }
    operation.add(addItem)
  }
  return (
    <div className='time-interval-array'>
      <Form.Array
        name={fieldsName?.name ? [fieldsName?.name, 'time_interval_list'] : 'time_interval_list'}
        onAdd={handleAdd}
        renderHeader={({ index: timeIndex }, { remove }) => {
          return (
            <>
              <span>时段{INDEX_MAP[timeIndex]}</span>
              {timeIntervalList?.length > 1 && !disabled && (
                <a
                  className='delete-second-btn'
                  onClick={() => {
                    Dialog.confirm({
                      className: 'hyb-com-dialog-wrap',
                      title: '您确定要删除该时段吗？',
                      onConfirm: () => {
                        remove(timeIndex)
                      }
                    })
                  }}
                >
                  删除时段
                </a>
              )}
            </>
          )
        }}
        renderAdd={() => {
          return disabled ? null : (
            <span className='add-second-btn'>
              <Image
                src='https://s.huiyunban.cn/1746806065627926528.png'
                width={18}
                height={18}
                className='diy-uploader'
              />
              添加时段
            </span>
          )
        }}
      >
        {(fields) =>
          fields.map(({ index: timeIndex }) => (
            <div key={timeIndex}>
              {showType && (
                <Form.Item
                  name={[timeIndex, 'time_range_type_code']}
                  label='时段类型'
                  rules={[{ required: true, message: '时段类型不能为空' }]}
                >
                  <ListSelect
                    disabled={disabled}
                    dataList={dictStore.getOptions('SCHEDULE_TIME_PERIOD_TYPE')}
                  />
                </Form.Item>
              )}
              <Form.Item
                name={[timeIndex, 'start_end_time']}
                label='上下班时间'
                rules={[
                  {
                    required: true,
                    type: 'array',
                    message: '上下班时间不能为空'
                  }
                ]}
                trigger='onChange'
              >
                <TimePicker
                  currentDay={currentDay || '1970-01-01'}
                  shiftType={fieldsName?.shiftType ? shiftType : 1}
                  disabled={disabled}
                  onChange={() => {}}
                />
              </Form.Item>
            </div>
          ))
        }
      </Form.Array>
    </div>
  )
}
export default TimeIntervalArray
/**
  example:
{
  "type": "TimeIntervalArray",
  "elementProps": {
    "fieldsName": {
      "name": "shift",
      "currentDay": "currentDay",
      "shiftType": "shiftType"
    }
  }
}
*/
